import { useLayoutEffect } from 'react';
import { createPath, useLocation, useNavigate } from 'react-router';
import { useCurrentOrganizationId } from 'hooks/use-current-organization-id';
import { getRouterLocation, isRouterNavigating } from 'services/router-service';

export const useAddOrganizationIdSearchParam = (): void => {
  const organizationId = useCurrentOrganizationId();
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    // The router renders its updates in a transition, so this can run for a location the router has already left, or
    // while a navigation waits on a lazy route. Replacing then would undo or cancel that navigation; the render for
    // the next location runs this effect again.
    if (isRouterNavigating() || createPath(getRouterLocation()) !== createPath(location)) {
      return;
    }

    const currentParams = new URLSearchParams(location.search);
    if (
      !location.pathname.includes('login') &&
      organizationId &&
      currentParams.get('organizationId') !== organizationId
    ) {
      currentParams.set('organizationId', organizationId);
      const newUrl = `${location.pathname}?${currentParams.toString()}${location.hash}`;
      navigate(newUrl, { replace: true });
    }
  }, [location, organizationId, navigate]);
};
